import {useSelector} from "react-redux";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IRevenue} from "../reducers/expertLessonsRevenueHistorySlice";

const useExpertRevenueManagementSelectors = () => {
  const lessonHistory = useSelector<RootSliceType, IRevenue["lessonHistory"]>(
    (state) => state.lessonsRevenueHistory.lessonHistory
  );

  const totalPoints = useSelector<RootSliceType, IRevenue["totalPoints"]>(
    (state) => state.lessonsRevenueHistory.totalPoints
  );
  const endDate = useSelector<RootSliceType, IRevenue["endDate"]>(
    (state) => state.lessonsRevenueHistory.endDate
  );
  const startDate = useSelector<RootSliceType, IRevenue["startDate"]>(
    (state) => state.lessonsRevenueHistory.startDate
  );
  const loading = useSelector<RootSliceType, IRevenue["loading"]>(
    (state) => state.lessonsRevenueHistory.loading
  );

  return {
    lessonHistory,
    endDate,
    startDate,
    loading,
    totalPoints
  };
};

export default useExpertRevenueManagementSelectors;
